var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('h2',[_vm._v("Distribuição por Tipo de Ação")]),_c('div',[_c('TypesTable',{attrs:{"requests":_vm.requests}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }